import {create} from 'zustand';
import { getSettings, updateSettings } from '../services/Settings';

const useAdminSettings = create((set, get) => ({
  // State
  adminSettings: null,
  settingsId: null,
  isLoading: false,
  error: null,

  // Actions
  setAdminSettings: (data) => set({ adminSettings: data }),
  
  // Fetch settings from API
  fetchSettings: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await getSettings();

      if (response?.status === 200 || response?.status === 201) {
        const settings = response.data.data;
        
        if (settings && settings._id) {
          set({ 
            adminSettings: settings,
            settingsId: settings._id,
            isLoading: false 
          });
          return settings;
        }
      }
      
      set({ isLoading: false, error: 'Failed to fetch settings' });
      return null;
    } catch (err) {
      console.error("Error fetching settings:", err);
      set({ 
        isLoading: false, 
        error: 'Failed to fetch settings. Please try again.' 
      });
      return null;
    }
  },

  // Update settings via API
  updateSettings: async (settingsData) => {
    const { settingsId, fetchSettings } = get();
    
    if (!settingsId) {
      set({ error: 'Settings not found. Please refresh the page.' });
      return false;
    }

    try {
      set({ isLoading: true, error: null });
      const response = await updateSettings(settingsId, settingsData);

      if (response?.status === 200 || response?.status === 201) {
        // Fetch fresh data from backend after successful update
        await fetchSettings();
        return true;
      } else {
        set({ 
          isLoading: false, 
          error: 'Failed to update settings. Please try again.' 
        });
        return false;
      }
    } catch (err) {
      console.error("Error updating settings:", err);
      set({ 
        isLoading: false, 
        error: 'Failed to update settings. Please try again.' 
      });
      return false;
    }
  },

  // Clear error
  clearError: () => set({ error: null }),
}));

export default useAdminSettings;
